import script from "./LoadingDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingDialog.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingDialog.vue?vue&type=style&index=0&id=238724c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-238724c9"]])

export default __exports__